import { useEffect, useState } from "react";
import { RestS } from "../../../rest/rest-service";
import moment from "moment";
import { GADimensions, GAEvents, IpNames, MetricValueType, TypeOfAmount, TypeOfFinanceOption } from "../../../interfaces/interfaces";
import { Modal } from "reactstrap";
import styles from './ProductEditForm.module.scss';
import { AiOutlineClose as CloseIcon } from "react-icons/ai";
import CircularLoader from "../../../components/common/CircularLoader/CircularLoader";
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import { Field, Form } from "react-final-form";
import arrayMutators from 'final-form-arrays'
import { FieldArray } from 'react-final-form-arrays'
import MeritoRadioButton from "../components/RadioButton/MeritoRadioButton";
import OutlinedFormInput from "../components/OutlinedFormInput/OutlinedFormInput";
import MeritoCheckbox from "../components/CustomCheckbox/MeritoCheckbox";
import { OnChange } from 'react-final-form-listeners'
import CategoryFormErrorFieldContainer from "../CategoryForm/ErrorFieldContainer";
import { GrUndo as UndoIcon } from "react-icons/gr";
import { OverlayTrigger } from "react-bootstrap";
import { RenderTooltip } from "../../../components/common/RenderTooltip";
import { LiaUserEditSolid } from "react-icons/lia";
import { GASendEvent, formatNumberWithComma, getLocalUser, onBlurFormatNumber, parseNumberForDB } from "../../../components/functions/utilities";
import SelectMetricCustomDropDown from "../components/SelectMetricDrodown/SelectMetricDropDownCustom";
import Switch from "react-switch";


type Props = {
    isOpen: boolean;
    setOpen: (value: boolean) => void,
    closeForm: (value: boolean) => void,
    productId: number,
    monthLabels: string[];
    ipConfigs: { [x: string]: any },
    showTaxColumn: boolean,
}

const showSellingOption = [IpNames.shopify]


const ProductEditForm = ({ isOpen, setOpen, closeForm, productId, monthLabels, ipConfigs, showTaxColumn }: Props) => {
    const [initialValues, setInitialValues] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const { id: userId } = getLocalUser();
    const [btnLoading, setBtnLoading] = useState(false);
    let user = getLocalUser();

    const dependentMetricLabel = {
        'SELLING_PRICE': 'Selling Price',
        'UNIT_COST': 'Unit Cost'
    }

    const fetchProductValues = async () => {
        try {
            setLoading(true);
            const response: any = await RestS.fetchProductEditData(productId);
            const productCostsObj = response?.productCosts && response?.productCosts?.length ? response?.productCosts.reduce((prev, curVal) => {
                prev[curVal.monthYear] = curVal;
                return prev;
            }, {}) : {};

            // console.log('monthLabels', monthLabels)
            const monthSet = new Set();
            let isShowUndoBtn = false;

            let isMissingSp = true;
            let isAllPercentage = true;
            const formattedInitialValues = {
                productName: response?.productName,
                sku: response?.sku,
                variant: response?.variant,
                taxRate: response?.taxRate,
                applyCostsToAllSkus: false,
                sameFor12: !response?.defaultCost && !response?.productCosts?.length ? true : response?.sameFor12,
                fixedAmountValue: response?.scheduledProductCost && !response?.scheduledProductCost['isPercentage'] ? response?.scheduledProductCost['value'] : null,
                fixedPercentageValue: response?.scheduledProductCost && response?.scheduledProductCost['isPercentage'] ? response?.scheduledProductCost['value'] : null,
                typeOfAmount: response?.scheduledProductCost && response?.scheduledProductCost['isPercentage'] ? TypeOfAmount.percentage : TypeOfAmount.fixed,
                packagingCostType: ["SELLING_PRICE", "UNIT_COST"].includes(response?.pkgDependentMetric) ? TypeOfAmount.percentage : TypeOfAmount.fixed,
                pkgFixedValue: !response?.pkgDependentMetric ? response?.packagingCost : null,
                pkgPercentageValue: response?.pkgDependentMetric ? response?.packagingCost : null,
                pkgDependentMetric: {
                    id: 1,
                    value: response?.pkgDependentMetric,
                    label: dependentMetricLabel[response?.pkgDependentMetric] ?? '',
                    feLabel: dependentMetricLabel[response?.pkgDependentMetric] ?? ''
                },
                integrationPartner: response?.integrationPartner,
                setForFutureMonths: response?.scheduledProductCost ? true : false,
                months: monthLabels.map((item, index) => {
                    const momentYear = moment(item, "MM-YYYY").format("YYYY");
                    let outputObj = null;
                    if (productCostsObj[item] != undefined) {
                        const currentObj = productCostsObj[item];
                        const currentCost = currentObj?.isPercentage ? currentObj?.percentageValue : currentObj?.inEffectValue == MetricValueType.apiCost ? currentObj?.apiCost : currentObj?.updatedCost;
                        if (!currentObj?.isPercentage) {
                            isAllPercentage = false;
                        }
                        if (currentObj?.inEffectValue == MetricValueType.updatedCost && currentObj?.apiCost) {
                            isShowUndoBtn = true;
                        }
                        outputObj = {
                            label: item,
                            value: currentCost,
                            apiCost: currentObj?.apiCost,
                            updatedCost: currentObj?.updatedCost,
                            editedBy: currentObj?.editedBy,
                            editedByName: currentObj.editedByName,
                            editedTime: currentObj?.editedTime,
                            isPercentage: currentObj?.isPercentage,
                            inEffectValue: currentObj?.inEffectValue,
                            isSeparator: monthSet.size > 0 && !monthSet.has(momentYear) ? true : false,
                            percentageValue: currentObj?.percentageValue,
                            isDefaultCost: false,
                        }
                        if (currentObj?.price) {
                            isMissingSp = false;
                        }
                    } else {
                        isAllPercentage = false;
                        outputObj = {
                            label: item,
                            value: response?.defaultCost ? response?.defaultCost : '',
                            apiCost: response?.defaultCost ? response?.defaultCost : 0,
                            updatedCost: 0,
                            editedBy: null,
                            editedByName: null,
                            editedTime: null,
                            isPercentage: false,
                            inEffectValue: response?.defaultCost ? MetricValueType.apiCost : MetricValueType.updatedCost,
                            isSeparator: monthSet.size > 0 && !monthSet.has(momentYear) ? true : false,
                            percentageValue: null,
                            isDefaultCost: true,
                        }
                    }
                    monthSet.add(momentYear);
                    return outputObj;
                })
            }
            // console.log('initialValues', formattedInitialValues);
            formattedInitialValues.typeOfAmount = isAllPercentage ? TypeOfAmount.percentage : formattedInitialValues.typeOfAmount;
            setInitialValues({ ...formattedInitialValues, isShowUndoBtn, isMissingSp });
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchProductValues();
    }, [productId]);

    const sendPnlUpdateGaEvent = (pnlUpdateType) => {
        GASendEvent(user, GAEvents.pnl_update, {
            [GADimensions.userLoginId]: user.id,
            [GADimensions.userType]: user.role,
            [GADimensions.pnl_type]: pnlUpdateType,
            [GADimensions.companyId]: user.companyId,
            [GADimensions.companyName]: user.companyName,
        });
    }

    const submitForm = async (values) => {
        try {
            // console.log('formValues', values);
            // console.log('values months', values?.months)
            setBtnLoading(true);
            const formattedFormValues = values.months.reduce((prev, item) => {
                if (values?.sameFor12) {
                    const checkToSaveCost = values?.typeOfAmount == TypeOfAmount.percentage ? values?.fixedPercentageValue != initialValues?.fixedPercentageValue : values?.fixedAmountValue != initialValues?.fixedAmountValue;
                    // check previous unit costs if same then don't update editedTime
                    const isPercentage = values?.typeOfAmount == TypeOfAmount.percentage;
                    // console.log('checkToSaveCost', checkToSaveCost)
                    if (values.sameFor12 != initialValues?.sameFor12 || checkToSaveCost || values?.typeOfAmount != initialValues?.typeOfAmount) {
                        prev.push({
                            ...item,
                            productId,
                            monthYear: item.label,
                            editedBy: userId,
                            editedTime: new Date(),
                            inEffectValue: MetricValueType.updatedCost,
                            percentageValue: isPercentage ? values?.fixedPercentageValue : null,
                            updatedCost: !isPercentage ? values?.fixedAmountValue : item.updatedCost,
                        })
                    } else {
                        // console.log('coming here')
                        // return prev;
                        prev.push({
                            ...item,
                            productId,
                            monthYear: item.label,
                        })
                    }
                } else if ((item.inEffectValue == MetricValueType.updatedCost && !item.editedBy) || (item.isDefaultCost && item.inEffectValue == MetricValueType.apiCost)) return prev; // item.isDefault - if this is true then we are picking cost from products table default cost and it should not be entered into product costs
                else {
                    prev.push({
                        ...item,
                        productId,
                        monthYear: item.label,
                        percentageValue: item.isPercentage ? item.value : null,
                        updatedCost: item.isPercentage ? item.updatedCost : item.inEffectValue == MetricValueType.updatedCost ? item.value : null,
                    })
                }
                return prev;
            }, [])

            // console.log("formattedMonth values", {
            //     ...values,
            //     productId,
            //     months: formattedFormValues,
            // })

            const finalFormValues = {
                ...values,
                productId,
                showTaxColumn: showTaxColumn,
                months: formattedFormValues,
                pkgDependentMetric: values?.packagingCostType == "fixed" ? null : values?.pkgDependentMetric?.value,
                packagingCost: values?.packagingCostType == "fixed" ? values?.pkgFixedValue : values?.pkgPercentageValue
            }
            // console.log('finalFormValues', finalFormValues)

            const data = await RestS.editProductData(finalFormValues)
            sendPnlUpdateGaEvent('product_cost_update')
            closeForm(true)

        } catch (error) {
            console.log(error);
            throw error;
        } finally {
            setBtnLoading(true);
        }
    }

    // console.log('initialValues', initialValues)

    return (
        <>
            <Modal size="md" centered isOpen={isOpen} toggle={() => {
                closeForm(false);
            }}>
                <div className={styles.formRootContainer}>
                    <div className={styles.headerContainer}>
                        <div className={styles.title}>
                            {`Update Product Costs`}
                        </div>
                        <div className={styles.actionButtonContainer}>
                            <MeritoButton icon={<CloseIcon />} type="secondary-1" onlyIcon={true} onClick={() => {
                                closeForm(false);
                            }} />
                        </div>
                    </div>
                    {loading ?
                        <>
                            <div className={styles.loadingContainer}>
                                <CircularLoader />
                            </div>
                            <div className={styles.footerContainer}>
                                <MeritoButton btnText="Cancel" type="tertiary" onClick={() => { }} />
                                <MeritoButton btnText="Add" type="primary-1" onClick={() => { }} />
                            </div>
                        </>
                        :
                        <Form initialValues={initialValues}
                            mutators={{ ...arrayMutators }}
                            validate={(values) => {
                                console.log('values', values);
                                let errors = {};
                                if (!values?.sameFor12 && values.months && values.months.length) {
                                    const isValuePresent = values.months.some((item) => item?.value != null && item?.value != "" && item?.value && item?.value != '0');
                                    // console.log('isValuePresent', isValuePresent)
                                    if (!isValuePresent) {
                                        errors = {
                                            ...errors,
                                            months: values.months.map(() => {
                                                return {
                                                    value: 'Enter at least one month’s value to Add'
                                                }
                                            })
                                        }
                                    }
                                }

                                if (values?.sameFor12 && values?.typeOfAmount == TypeOfAmount.fixed) {
                                    if (!values?.fixedAmountValue && values?.fixedAmountValue !== 0) {
                                        // Show the message for missing value
                                        // console.log("Please provide a fixed amount value.");
                                        errors = {
                                            ...errors,
                                            fixedAmountValue: 'Add Unit Cost'
                                        }
                                    }
                                    // Check if fixedAmountValue is 0 or less
                                    else if (values?.fixedAmountValue <= 0) {
                                        // Show the message for zero or negative value
                                        // console.log("Fixed amount value must be greater than 0.");
                                        errors = {
                                            ...errors,
                                            fixedAmountValue: 'Unit Cost should be greater than 0'
                                        }
                                    }
                                }

                                if (values?.sameFor12 && values?.typeOfAmount == TypeOfAmount.percentage) {
                                    if (!values?.fixedPercentageValue && values?.fixedPercentageValue !== 0) {
                                        // Show the message for missing value
                                        // console.log("Please provide a fixed amount value.");
                                        errors = {
                                            ...errors,
                                            fixedPercentageValue: 'Add Unit Cost'
                                        }
                                    }
                                    // Check if fixedPercentageValue is 0 or less
                                    else if (values?.fixedPercentageValue <= 0) {
                                        // Show the message for zero or negative value
                                        // console.log("Fixed amount value must be greater than 0.");
                                        errors = {
                                            ...errors,
                                            fixedPercentageValue: 'Unit Cost should be greater than 0'
                                        }
                                    }
                                }


                                if (showTaxColumn && !values?.taxRate && values?.taxRate != 0) {
                                    errors = {
                                        ...errors,
                                        taxRate: 'Add GST'
                                    }
                                }

                                if (showTaxColumn && values?.taxRate && (values?.taxRate < 0 || values?.taxRate > 100)) {
                                    errors = {
                                        ...errors,
                                        taxRate: 'GST should be between 0 and 100'
                                    }
                                }

                                if (values?.packagingCostType == 'fixed') {
                                    if (!values?.pkgFixedValue && values?.pkgFixedValue != 0) {
                                        errors = {
                                            ...errors,
                                            pkgFixedValue: 'Add Packaging Cost'
                                        }
                                    }
                                }
                                // console.log('!values?.pkgDependentMetric', !values?.pkgDependentMetric)
                                if (values?.packagingCostType != 'fixed' && (!values?.pkgDependentMetric || !values?.pkgDependentMetric?.value)) {
                                    errors = {
                                        ...errors,
                                        pkgPercentageValue: 'Please select a metric'
                                    }
                                }

                                if (values?.packagingCostType != 'fixed' && values?.pkgDependentMetric) {
                                    if (!values?.pkgPercentageValue && values?.pkgPercentageValue != 0) {
                                        errors = {
                                            ...errors,
                                            pkgPercentageValue: 'Add Packaging Cost'
                                        }
                                    }
                                    // if(values?.pkgPercentageValue && (values?.))
                                }

                                // if (!values?.pkgDependentMetric) {
                                //     return {
                                //         pkgDependentMetric: 'Please select a metric'
                                //     }
                                // }
                                return errors;
                            }}
                            onSubmit={(values) => {
                                // console.log('values', values);
                                submitForm(values);
                            }}
                            // debug={(state) => {
                            //     console.log('formState', state?.values)
                            // }}
                            render={({ values, handleSubmit, pristine, hasValidationErrors, form: { change, batch, getFieldState }, errors, touched }) => {
                                // console.log('allValues', values)
                                // console.log('touched', touched)
                                // console.log('errors', errors);
                                return (
                                    <form onSubmit={handleSubmit}>
                                        <div className={styles.formBodyContainer}>
                                            <div className={styles.productNameRootContainer}>
                                                <div className={styles.labelText}>
                                                    Product Name
                                                </div>
                                                <div className={styles.productContainer}>
                                                    {values?.integrationPartner ?
                                                        <div className={styles.imageContainer}>
                                                            <img src={ipConfigs[values?.integrationPartner]['logo']} alt="" />
                                                        </div> : null}
                                                    <div className={styles.productNameContainer}>
                                                        <div className={styles.productName}>
                                                            {values?.productName}
                                                        </div>
                                                        <div className={styles.productDetails}>
                                                            {values?.variant ? <div className={styles.productDetailsText}>
                                                                {values?.variant}
                                                            </div> : null}
                                                            {values?.sku && values?.variant ? <div className={styles.productDetailsSeparator}></div> : null}
                                                            <div className={styles.productDetailsText}>
                                                                {values?.sku}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            {showTaxColumn ? <div className={styles.taxRateRootContainer}>
                                                <div className={styles.labelText}>
                                                    GST
                                                </div>


                                                <Field
                                                    name="taxRate"
                                                >
                                                    {(props) => (
                                                        <>
                                                            <div className={styles.taxFieldRootContainer}>

                                                                <div className={styles.taxFieldContainer}>
                                                                    <OutlinedFormInput
                                                                        {...props.input}
                                                                        inpuType="number"
                                                                        showError={false}
                                                                        showBorder={true}
                                                                        containerStyles={{ borderTopRightRadius: '0', borderBottomRightRadius: '0', borderRight: "none", padding: "0.52rem 0.75rem" }}
                                                                        name={props.input.name}
                                                                        value={props.input.value}
                                                                        onChange={(e) => {
                                                                            // console.log('value', e.target.value)
                                                                            const numericValue = parseNumberForDB(e.target.value, true);
                                                                            props.input.onChange(numericValue);
                                                                        }}
                                                                        onBlur={() => {
                                                                            const value = props.input.value;
                                                                            const formattedValue = onBlurFormatNumber(value, 2);
                                                                            props.input.onChange(formattedValue);
                                                                            props.input.onBlur();
                                                                        }}
                                                                        error={props.meta.error}
                                                                        touched={props.meta.touched}
                                                                        unitPlaceHolder="% of"
                                                                        unitPosition="right"
                                                                        maxLength={10}
                                                                    />


                                                                </div>
                                                                <div className={`${styles.taxFieldLabelContainer} ${props.meta.touched && props.meta.error ? styles.invalid : ''}`}>
                                                                    <div className={styles.label}>
                                                                        Net Sales Price
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className={styles.errorText}>
                                                                {props.meta.touched && props.meta.error ? props.meta.error : ''}
                                                            </div>
                                                        </>
                                                    )}
                                                </Field>


                                            </div> : null}

                                            <div className={styles.fixedCostsContainer}>
                                                <Field name="packagingCostType" >
                                                    {(props) => {
                                                        return (
                                                            <MeritoRadioButton
                                                                {...props.input}
                                                                label="Packaging Cost"
                                                                radioLabels={[
                                                                    {
                                                                        label: "Actuals",
                                                                        value: 'fixed',
                                                                        disabledState: false,
                                                                    },
                                                                    {
                                                                        label: "Percentage of",
                                                                        value: 'percentage',
                                                                        disabledState: false
                                                                    }
                                                                ]}
                                                                name={props.input.name}
                                                                value={props.input.value}
                                                                onChange={props.input.onChange}
                                                                error={props.meta.error}
                                                                fieldContainerStyle={{ marginBottom: "0.8rem" }}
                                                            />
                                                        )
                                                    }}
                                                </Field>
                                                {values?.packagingCostType == TypeOfAmount.fixed ?

                                                    <div className={styles.inputContainer}>
                                                        <Field
                                                            name="pkgFixedValue"
                                                        >
                                                            {(props) => (
                                                                <>
                                                                    <OutlinedFormInput
                                                                        {...props.input}
                                                                        name={props.input.name}
                                                                        isCurrency={true}
                                                                        allowDecimals={true}
                                                                        onChange={(e) => {
                                                                            console.log('e', e.target.value)
                                                                            const numericValue = parseNumberForDB(e.target.value, true);
                                                                            props.input.onChange(numericValue);
                                                                        }}
                                                                        value={props.input.value}
                                                                        error={props.meta.error}
                                                                        placeholder="Enter Amount"
                                                                        touched={props.meta.touched}
                                                                        unitPlaceHolder="₹"
                                                                        maxLength={10}
                                                                    />
                                                                    {/* <div className={styles.errorText}>
                                                                        {props.meta.touched && props.meta.error ? props.meta.error : ''}
                                                                    </div> */}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </div>
                                                    :
                                                    <>
                                                        <div className={styles.multiApplyContainer}>
                                                            <div className={styles.packagingCostContainer} style={{ width: '100%' }}>
                                                                <div style={{ 'flex': '0.9' }}>
                                                                    <Field
                                                                        name="pkgPercentageValue"
                                                                    >
                                                                        {(props) => (
                                                                            <OutlinedFormInput
                                                                                {...props.input}
                                                                                showError={false}
                                                                                inpuType="number"
                                                                                containerStyles={{ borderTopRightRadius: '0', borderBottomRightRadius: '0', borderRight: "none", padding: "0.52rem 0.75rem" }}
                                                                                name={props.input.name}
                                                                                value={props.input.value}
                                                                                // onChange={props.input.onChange}
                                                                                onChange={(e) => {
                                                                                    // console.log('value', e.target.value)
                                                                                    const numericValue = parseNumberForDB(e.target.value, true);
                                                                                    props.input.onChange(numericValue);
                                                                                }}
                                                                                onBlur={() => {
                                                                                    const value = props.input.value;
                                                                                    const formattedValue = onBlurFormatNumber(value, 2);
                                                                                    props.input.onChange(formattedValue);
                                                                                    if (!showSellingOption.includes(values?.integrationPartner)) {
                                                                                        change('pkgDependentMetric', {
                                                                                            id: 1,
                                                                                            value: 'UNIT_COST',
                                                                                            label: dependentMetricLabel["UNIT_COST"],
                                                                                            feLabel: dependentMetricLabel["UNIT_COST"]
                                                                                        });
                                                                                    }
                                                                                    props.input.onBlur();
                                                                                }}
                                                                                error={props.meta.error}
                                                                                touched={props.meta.touched}
                                                                                unitPlaceHolder="% of"
                                                                                unitPosition="right"
                                                                                maxLength={10}
                                                                                showErrorBorder={(touched?.pkgDependentMetric || touched?.pkgPercentageValue) && (errors?.pkgDependentMetric || errors?.pkgPercentageValue)}
                                                                            />
                                                                        )}
                                                                    </Field>
                                                                </div>
                                                                <div style={{ 'flex': '3' }}>
                                                                    <Field
                                                                        name="pkgDependentMetric"
                                                                    >
                                                                        {(props) => {
                                                                            return (
                                                                                <>
                                                                                    {showSellingOption.includes(values?.integrationPartner) ?
                                                                                        <SelectMetricCustomDropDown value={props.input.value} handleSelectedValue={(value) => {
                                                                                            console.log('selectedMetric', value)
                                                                                            props.input.onChange(value);
                                                                                        }} options={[{
                                                                                            id: 1,
                                                                                            label: dependentMetricLabel["SELLING_PRICE"],
                                                                                            type: TypeOfFinanceOption.financeMetric,
                                                                                            value: "SELLING_PRICE",
                                                                                            feLabel: dependentMetricLabel["SELLING_PRICE"]
                                                                                        },
                                                                                        {
                                                                                            id: 1,
                                                                                            label: dependentMetricLabel["UNIT_COST"],
                                                                                            type: TypeOfFinanceOption.financeMetric,
                                                                                            value: "UNIT_COST",
                                                                                            feLabel: dependentMetricLabel["UNIT_COST"],
                                                                                        }]} errorBorder={(touched?.pkgDependentMetric || touched?.pkgPercentageValue) && (errors?.pkgDependentMetric || errors?.pkgPercentageValue)} />
                                                                                        :
                                                                                        <div className={`${styles.packagingMetricContainer} ${errors?.pkgPercentageValue && touched?.pkgPercentageValue ? styles.invalid : ''}`}>
                                                                                            Unit Cost
                                                                                        </div>
                                                                                    }
                                                                                </>

                                                                            )
                                                                        }}
                                                                    </Field>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {
                                                            touched?.pkgDependentMetric || touched?.pkgPercentageValue ?
                                                                <div className={styles.errorText}>
                                                                    {errors?.pkgDependentMetric ? errors?.pkgDependentMetric : errors?.pkgPercentageValue ? errors?.pkgPercentageValue : ''}
                                                                </div> : null
                                                        }
                                                    </>
                                                }
                                            </div>

                                            <div className={styles.fixedCostsContainer}>
                                                <Field name="typeOfAmount" >
                                                    {(props) => {
                                                        // const percentageOption = showSellingOption.includes(values?.integrationPartner) ? [{
                                                        //     label: "Percentage of",
                                                        //     value: 'percentage',
                                                        //     disabledState: values?.isMissingSp,
                                                        //     disabledMessage: 'Selling Price is unavailable for this product.'
                                                        // }] : [];
                                                        return (
                                                            <MeritoRadioButton
                                                                {...props.input}
                                                                label="Unit Cost"
                                                                radioLabels={[
                                                                    {
                                                                        label: "Actuals",
                                                                        value: 'fixed',
                                                                        disabledState: false,
                                                                    },
                                                                    // ...percentageOption
                                                                    {
                                                                        label: "Percentage of",
                                                                        value: 'percentage',
                                                                        disabledState: values?.isMissingSp,
                                                                        disabledMessage: 'Selling Price is unavailable for this product.'
                                                                    },

                                                                ]}
                                                                name={props.input.name}
                                                                value={props.input.value}
                                                                onChange={props.input.onChange}
                                                                error={props.meta.error}
                                                                fieldContainerStyle={{ marginBottom: "0.8rem" }}
                                                            />
                                                        )
                                                    }}
                                                </Field>
                                                {values?.typeOfAmount == TypeOfAmount.fixed ?
                                                    <div className={styles.multiApplyContainer}>
                                                        {/* <div className={styles.valueContainer}> */}
                                                        <div className={`${styles.inputContainer} ${values?.sameFor12 ? styles.fullWidth : ''}`}>
                                                            <Field
                                                                name="fixedAmountValue"
                                                            >
                                                                {(props) => (
                                                                    <OutlinedFormInput
                                                                        {...props.input}
                                                                        name={props.input.name}
                                                                        isCurrency={true}
                                                                        allowDecimals={true}
                                                                        onChange={(e) => {
                                                                            // console.log('e', e.target.value)
                                                                            const numericValue = parseNumberForDB(e.target.value, true);
                                                                            props.input.onChange(numericValue);
                                                                        }}
                                                                        value={props.input.value}
                                                                        error={props.meta.error}
                                                                        placeholder="Enter Amount"
                                                                        touched={props.meta.touched}
                                                                        unitPlaceHolder="₹"
                                                                        maxLength={21}
                                                                    />
                                                                )}
                                                            </Field>
                                                        </div>

                                                        {!values?.sameFor12 ? <MeritoButton btnType="button" type="secondary-2" btnText="Apply to All" onClick={() => {
                                                            const updatedMonths = values.months.map((item, index) => {
                                                                return {
                                                                    ...item,
                                                                    inEffectValue: MetricValueType.updatedCost,
                                                                    editedBy: userId,
                                                                    editedTime: new Date(),
                                                                    value: values.fixedAmountValue,
                                                                    isPercentage: false,
                                                                }
                                                            })
                                                            change('months', updatedMonths);
                                                        }} /> : null}
                                                    </div>
                                                    :
                                                    <div className={styles.multiApplyContainer}>
                                                        <div className={`${styles.valueContainer} ${values?.sameFor12 ? styles.fullWidth : ''}`}>
                                                            <Field
                                                                name="fixedPercentageValue"
                                                            >
                                                                {(props) => (
                                                                    <>
                                                                        <div className={styles.valueFlexContainer}>
                                                                            <div className={styles.inputContainer}>
                                                                                <OutlinedFormInput
                                                                                    {...props.input}
                                                                                    inpuType="number"
                                                                                    containerStyles={{ borderTopRightRadius: '0', borderBottomRightRadius: '0', borderRight: "none", padding: "0.52rem 0.75rem" }}
                                                                                    name={props.input.name}
                                                                                    value={props.input.value}
                                                                                    onChange={(e) => {
                                                                                        // console.log('value', e.target.value)
                                                                                        const numericValue = parseNumberForDB(e.target.value, true);
                                                                                        props.input.onChange(numericValue);
                                                                                    }}
                                                                                    onBlur={() => {
                                                                                        const value = props.input.value;
                                                                                        const formattedValue = onBlurFormatNumber(value, 2);
                                                                                        props.input.onChange(formattedValue);
                                                                                        props.input.onBlur();
                                                                                    }}
                                                                                    showError={false}
                                                                                    showBorder={true}
                                                                                    error={props.meta.error}
                                                                                    touched={props.meta.touched}
                                                                                    unitPlaceHolder="% of"
                                                                                    unitPosition="right"
                                                                                    maxLength={10}
                                                                                />
                                                                            </div>

                                                                            <div className={`${styles.selectedMetricContainer} ${props.meta.error && props.meta.touched ? styles.invalid : ''}`}>
                                                                                Selling Price
                                                                            </div>
                                                                        </div>
                                                                        {props.meta.error && props.meta.touched ? <div className={styles.errorText}>
                                                                            {props.meta.error}
                                                                        </div> : null}
                                                                    </>
                                                                )}
                                                            </Field>

                                                            {/* <Field
                                                                name="selectedMetric"
                                                            >
                                                                {(props) => (
                                                                    <SelectMetricCustom value={props.input.value} handleSelectedValue={(value) => {
                                                                        console.log('selectedMetric', value)
                                                                        props.input.onChange(value);
                                                                    }} options={metricOptions} />
                                                                )}
                                                            </Field> */}


                                                        </div>
                                                        {!values?.sameFor12 ? <div className={styles.btnContainer}>
                                                            <MeritoButton btnType="button" type="secondary-2" btnText="Apply to All" onClick={() => {
                                                                const updatedMonths = values.months.map((item, index) => {
                                                                    return {
                                                                        ...item,
                                                                        editedBy: userId,
                                                                        editedTime: new Date(),
                                                                        inEffectValue: MetricValueType.updatedCost,
                                                                        value: values.fixedPercentageValue,
                                                                        isPercentage: true,
                                                                    }
                                                                })
                                                                change('months', updatedMonths);
                                                            }} />
                                                        </div> : null}


                                                    </div>
                                                }
                                                {/* <div className={styles.checkBoxContainer}>
                                                    <Field name="setForFutureMonths">
                                                        {(props) => {
                                                            // console.log('values?.fixedAmountValue || values?.fixedPercentageValue', values?.fixedAmountValue || values?.fixedPercentageValue ? false : true)
                                                            return (
                                                                <MeritoCheckbox
                                                                    {...props.input}
                                                                    disabled={values?.fixedAmountValue || values?.fixedPercentageValue ? false : true}
                                                                    name={props.input.name}
                                                                    value={props.input.value}
                                                                    onChange={props.input.onChange}
                                                                    error={props.meta.error}
                                                                    touched={props.meta.touched}
                                                                />
                                                            )
                                                        }}
                                                    </Field>
                                                    <div className={`${styles.checkboxLabel} ${values?.fixedAmountValue || values?.fixedPercentageValue ? '' : styles.disabled}`}>
                                                        Set this as a default value for future months
                                                    </div>
                                                </div> */}
                                            </div>

                                            <OnChange name="typeOfAmount">
                                                {(value, previous) => {
                                                    // do something
                                                    // console.log('typeOfAmount changing', value)
                                                    if (value == "fixed") {
                                                        const oldMonthValues = initialValues['months'];
                                                        const oldValues = initialValues['months'].map((item, index) => {
                                                            return {
                                                                ...item,
                                                                editedBy: item?.editedBy && !item.isPercentage ? item.editedBy : null,
                                                                editedTime: item?.editedTime && !item.isPercentage ? item.editedTime : null,
                                                                editedByName: item?.editedByName && !item.isPercentage ? item.editedByName : null,
                                                                value: item?.isPercentage ? '' : item?.inEffectValue == MetricValueType?.updatedCost ? item.updatedCost : item.apiCost,
                                                                isPercentage: false,
                                                            }
                                                        });

                                                        // console.log('oldValues', oldValues)
                                                        change('months', oldValues);
                                                    }
                                                    if (value == "percentage") {
                                                        const percentageValues = initialValues['months'].map((item, index) => {
                                                            return {
                                                                ...item,
                                                                isPercentage: true,
                                                                inEffectValue: MetricValueType.updatedCost,
                                                                editedBy: item?.editedBy && item.isPercentage ? item.editedBy : null,
                                                                editedTime: item?.editedTime && item.isPercentage ? item.editedTime : null,
                                                                editedByName: item?.editedByName && item.isPercentage ? item.editedByName : null,
                                                                value: item?.isPercentage ? item.percentageValue : '',
                                                            }
                                                        })
                                                        change("months", percentageValues)
                                                    }
                                                }}
                                            </OnChange>


                                            <div className={styles.sameFor12RootContainer}>
                                                <div className={styles.sameFor12Title}>
                                                    Unit cost is the same for this product every month?
                                                </div>
                                                <Field name="sameFor12">
                                                    {(props) => {
                                                        return (
                                                            <Switch
                                                                draggable={false}
                                                                checked={props.input.value}
                                                                onChange={(checkstatus) => {
                                                                    props.input.onChange({ target: { value: checkstatus } })
                                                                }}
                                                                onColor="#100828"
                                                                offColor="#D5D5D5"
                                                                handleDiameter={20}
                                                                uncheckedIcon={false}
                                                                checkedIcon={false}
                                                                boxShadow="0px 1px 3px rgba(0, 0, 0, 0.6)"
                                                                activeBoxShadow="0px 0px 1px 1px rgba(0, 0, 0, 0.2)"
                                                                height={24}
                                                                width={43}
                                                                className={styles.switch}
                                                                id="material-switch"
                                                            />
                                                        )
                                                    }}
                                                </Field>
                                            </div>
                                            <CategoryFormErrorFieldContainer />
                                            {!values?.sameFor12 ? <div className={styles.monthsRootContainer}>

                                                <FieldArray name="months">
                                                    {({ fields }) => (
                                                        <>
                                                            {fields.map((name, index) => {
                                                                const currentMonthValue = values.months[index];
                                                                const undoButton = (
                                                                    <>
                                                                        {values.months[index].inEffectValue == MetricValueType.updatedCost && (values.months[index]?.value || initialValues["months"][index]?.value) && values.months[index]?.apiCost && values.typeOfAmount != "percentage" ?
                                                                            <OverlayTrigger
                                                                                placement="bottom"
                                                                                delay={{ show: 100, hide: 100 }}
                                                                                overlay={(props) =>
                                                                                    RenderTooltip(
                                                                                        props,
                                                                                        `Use ${values?.integrationPartner} value`
                                                                                    )
                                                                                }
                                                                            >
                                                                                <button type="reset" className={styles.undoBtn} onClick={() => {
                                                                                    // console.log(`${name}.inEffectValue`)
                                                                                    // console.log('index', index, currentMonthValue?.apiCost)
                                                                                    batch(() => {
                                                                                        change(`${name}.inEffectValue`, MetricValueType.apiCost);
                                                                                        change(`${name}.value`, currentMonthValue?.apiCost);
                                                                                        change(`${name}.isPercentage`, false)
                                                                                    })
                                                                                }}>
                                                                                    <UndoIcon />
                                                                                </button>
                                                                            </OverlayTrigger>
                                                                            :
                                                                            <button type="reset" className={`${styles.undoBtn} ${styles.hidden}`}>
                                                                                <UndoIcon />
                                                                            </button>}
                                                                    </>
                                                                )
                                                                return (
                                                                    <>
                                                                        {values.months[index].isSeparator ? <div className={styles.separator}></div> : null}

                                                                        <div key={index} className={styles.monthsContainer}>
                                                                            <div className={styles.leftContainer}>

                                                                                <div className={styles.monthLabel}>
                                                                                    {`${moment(values.months[index].label, "MM-YYYY").format("MMM YYYY")}`}
                                                                                </div>

                                                                                {values.months[index].inEffectValue == MetricValueType.apiCost && values.months[index].apiCost && values.months[index].value ? <div className={styles.iconContainer}>
                                                                                    <img src={ipConfigs[values?.integrationPartner]['logo']} />
                                                                                </div> : values.months[index].editedBy && values.months[index].inEffectValue == MetricValueType.updatedCost && (values.months[index].value || initialValues['months'][index].value || values.months[index].value == 0 || initialValues['months'].value == 0) ?
                                                                                    <OverlayTrigger
                                                                                        placement="bottom"
                                                                                        delay={{ show: 100, hide: 100 }}
                                                                                        overlay={(props) =>
                                                                                            RenderTooltip(
                                                                                                props,
                                                                                                `Edited by ${currentMonthValue?.editedBy == userId ? 'you' : currentMonthValue?.editedByName}  ${currentMonthValue?.editedTime ? `on ${moment(currentMonthValue?.editedTime).format("MMM DD, YYYY")}` : ''}`
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <div className={styles.iconContainer}>
                                                                                            <LiaUserEditSolid />
                                                                                        </div>
                                                                                    </OverlayTrigger>
                                                                                    : null
                                                                                }
                                                                            </div>
                                                                            <div className={styles.inputFieldContainer}>
                                                                                <Field
                                                                                    name={`${name}.value`}

                                                                                // validate={(value) => {
                                                                                //     if (!value) return "Enter at least one month’s value to Add";
                                                                                // }}
                                                                                >
                                                                                    {(props) => (
                                                                                        <OutlinedFormInput
                                                                                            {...props.input}
                                                                                            showError={false}
                                                                                            inpuType="number"
                                                                                            allowDecimals={true}
                                                                                            // containerStyles={{ borderTopRightRadius: '0', borderBottomRightRadius: '0', borderRight: "none", padding: "0.52rem 0.75rem" }}
                                                                                            name={props.input.name}
                                                                                            value={props.input.value}
                                                                                            onChange={(e) => {
                                                                                                // console.log('value', e.target.value)
                                                                                                const numericValue = parseNumberForDB(
                                                                                                    e.target.value,
                                                                                                    true
                                                                                                );
                                                                                                props.input.onChange(numericValue);
                                                                                            }}
                                                                                            error={props.meta.error}
                                                                                            touched={props.meta.touched}
                                                                                            onBlur={(e) => {

                                                                                                // console.log('onBlur triggering')
                                                                                                // if (currentMonthValue?.inEffectValue == MetricValueType.updatedCost && currentMonthValue?.updatedCost && currentMonthValue?.apiCost) {
                                                                                                const value = props.input.value;
                                                                                                const formattedValue = onBlurFormatNumber(value, 2);
                                                                                                props.input.onChange(formattedValue);
                                                                                                if (props.input.value != currentMonthValue?.apiCost) {
                                                                                                    batch(() => {
                                                                                                        change(`${name}.inEffectValue`, MetricValueType.updatedCost);
                                                                                                        change(`${name}.editedBy`, userId);
                                                                                                        change(`${name}.editedTime`, new Date());
                                                                                                    })
                                                                                                }
                                                                                                props.input.onBlur(e);
                                                                                            }}
                                                                                            unitPlaceHolder={currentMonthValue?.isPercentage && currentMonthValue?.inEffectValue != MetricValueType.apiCost ? "%" : '₹'}
                                                                                            unitPosition={currentMonthValue?.isPercentage && currentMonthValue?.inEffectValue != MetricValueType.apiCost ? "right" : null}
                                                                                            buttonEle={!values?.months[index].isPercentage ? undoButton : null}
                                                                                            maxLength={values?.months[index].isPercentage ? 10 : 21}
                                                                                            isCurrency={values?.months[index].isPercentage ? false : true}
                                                                                        />
                                                                                    )}
                                                                                </Field>


                                                                            </div>
                                                                        </div>
                                                                    </>

                                                                )
                                                            })}
                                                        </>
                                                    )}
                                                </FieldArray>

                                            </div> : null}

                                        </div>
                                        <div className={styles.footerBanner}>
                                            <Field name="applyCostsToAllSkus" >
                                                {(props) => {
                                                    return (
                                                        <MeritoCheckbox
                                                            {...props.input}
                                                            name={props.input.name}
                                                            value={props.input.value}
                                                            onChange={props.input.onChange}
                                                            error={props.meta.error}
                                                            touched={props.meta.touched}
                                                        />
                                                    )
                                                }}
                                            </Field>
                                            <div className={styles.footerBannerText}>
                                                {`Apply this cost for all SKUs of this Product`}
                                            </div>
                                        </div>
                                        <div className={styles.footerContainer}>
                                            <MeritoButton btnType="reset" btnText="Cancel" type="tertiary" onClick={() => closeForm(false)} />
                                            <MeritoButton loading={btnLoading} btnType="submit" btnText="Update Costs" type="primary-1" onClick={handleSubmit} />
                                        </div>
                                    </form>
                                )
                            }}
                        />
                    }
                </div>
            </Modal>
        </>
    );
}

export default ProductEditForm;